/**
 * Learning log: anything worth writing down: books, photography, craft, work.
 * Newest entry first. Add new entries to the top.
 * Fields: date (YYYY-MM-DD), tag (short category), title, body (1-3 sentences).
 * The LOG.NN index is derived from position, so no need to number entries.
 * These are placeholder entries. Replace them with your own.
 */
const LOG = [
  {
    date: "2026-06-18",
    tag: "Reading",
    title: "Foroux on consistency",
    body:
      "Darius Foroux's argument that output compounds only when the schedule is boring finally landed. The weeks I plan nothing ambitious and just show up produce more than the weeks I plan everything.",
  },
  {
    date: "2026-04-11",
    tag: "Photography",
    title: "Meter for the highlights",
    body:
      "Shooting at dusk in Halifax harbour: exposing for the sky and lifting shadows later keeps far more of the frame than the reverse. Blown highlights are gone; dark water is recoverable.",
  },
  {
    date: "2026-02-23",
    tag: "Work",
    title: "Chunking beats the embedding model",
    body:
      "Swapping embedding models moved retrieval quality a few points. Restructuring the corpus into heading-aware chunks moved it far more. The shape of the data mattered more than the model reading it.",
  },
  {
    date: "2025-12-07",
    tag: "Tennis",
    title: "Slow is smooth",
    body:
      "Took pace off the first serve for a month to fix the toss. Points got shorter, not longer. Placement under control beats speed without it. Suspect this generalizes.",
  },
];

export default LOG;
